import * as z from "zod";

export const CHANGE_REVIEW_TIMEOUT_MS = 5 * 60_000;

export const reviewSchema = z.object({
  summary: z.string(),
  changes: z.array(
    z.object({
      title: z.string(),
      before: z.string(),
      after: z.string(),
      paths: z.array(z.string()),
      discussionEntryId: z.string().nullable(),
    })
  ),
});

export type PublishedChange = z.infer<typeof reviewSchema>["changes"][number];

export type PublishedChangeReview = {
  commitId: string;
  baseCommitId: string | null;
  status: "generating" | "complete" | "error";
} & z.infer<typeof reviewSchema>;

export function publishedChangeReviewContext(review: PublishedChangeReview) {
  if (review.status !== "complete") return null;
  return `The draft started from published commit ${review.commitId}. This is historical context, not a new request. Use readVersionChat with this commitId to read the discussion when needed.\n${JSON.stringify({ summary: review.summary, changes: review.changes })}`;
}
